import { FC, useEffect, useState } from "react";

/** Live "~5m 12s" countdown to a unix-seconds target; renders nothing once
 * the target passes (the surrounding status copy keeps carrying the state). */
export const Countdown: FC<{ target: number; className?: string }> = ({
  target,
  className = "text-xs text-sr-lemon-muted tabular-nums",
}) => {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, target - Math.floor(Date.now() / 1000)),
  );

  useEffect(() => {
    const tick = () =>
      setRemaining(Math.max(0, target - Math.floor(Date.now() / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  if (remaining <= 0) return null;
  const m = Math.floor(remaining / 60);
  const s = remaining % 60;
  const text = m > 0 ? `~${m}m ${String(s).padStart(2, "0")}s` : `~${s}s`;
  return <span className={className}>{text}</span>;
};
